// extracted by mini-css-extract-plugin
export var indeterminate = "_47-6";
export var md = "_47-5";
export var semantic = "_47-7";
export var sm = "_47-4";
export var text = "_47-8";
export var toggleControl = "_47-0";
export var toggleInput = "_47-1";
export var toggleSwitch = "_47-2";
export var xs = "_47-3";